<div class="content-wrapper">
  <div class="page-title-box">
    <h4>User List</h4>
  </div>

  <div class="card card-nobody">
    <div class="card-body">
      <div class="row mb-0">
        <div class="col-lg-8 col-sm-8">
          <div class="row search-box">
            <div class="col-lg-5 mb-2">
              <div class="position-relative">
                <input
                  [formControl]="searchText"
                  class="form-control border-light rounded"
                  placeholder="Search..."
                  type="search"
                />
                <i class="uil uil-search search-icon"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-4">
          <div class="mt-4 mt-sm-0 d-flex justify-content-sm-end gap-4">
            <div
              *ngIf="
                [companies.Sea].includes(company) ||
                ([companies.Seca].includes(company) && isAdminOnly && isHq)
              "
              class="col-lg-1 mt-4px mr-12px"
            >
              <div class="position-relative">
                <button
                  (click)="exportResult()"
                  class="btn btn-primary btn-sm"
                  type="submit"
                >
                  Export
                </button>
              </div>
            </div>
            <div
              *ngIf="isCreatable && !isAdminViewerRole"
              class="align-items-center"
            >
              <button (click)="modalOpen()" class="btn btn-dark" type="button">
                <font-awesome style="color: white">New</font-awesome>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div [ngClass]="{showDetail}" class="table-wrapper">
        <app-dp-list
          (pageEvent)="onPageEvent($event)"
          (toggleDetail)="showDetail = $event"
          [pagedResponse]="pagedResponse"
          [selectedItem]="selectedData"
          [showDetail]="showDetail"
        >
          <table
            [ngClass]="{
              table: !showDetail,
              'table-list': !showDetail,
              'align-middle': !showDetail,
              'table-nowrap': !showDetail,
              'table-check': !showDetail,
              'w-100': true
            }"
          >
            <thead>
              <tr>
                <th [hidden]="showDetail">No.</th>
                <th
                  [attr.data-sort-fields]="'organization'"
                  [hidden]="showDetail"
                >
                  Organization
                </th>
                <th [hidden]="showDetail">Username</th>
                <th [hidden]="showDetail">First Name</th>
                <th [hidden]="showDetail">Last Name</th>
                <th
                  [attr.data-sort-fields]="'roles.groups'"
                  [hidden]="showDetail"
                >
                  Roles
                </th>
                <th [attr.data-sort-fields]="'status'" [hidden]="showDetail">
                  Status
                </th>
                <th [attr.data-sort-fields]="'lastLogin'" [hidden]="showDetail">
                  Last Login
                </th>
                <th
                  [attr.data-sort-fields]="'auth.createdAt'"
                  [hidden]="showDetail"
                >
                  Create Date
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                (click)="selectRow(user)"
                *ngFor="let user of userData; let i = index"
                [class.active]="user.username === selectedData?.username"
              >
                <ng-container *ngIf="!showDetail; else detailListCols">
                  <td>{{ i + 1 }}</td>
                  <td>{{ user.organizationName }}</td>
                  <td>{{ user.username }}</td>
                  <td>{{ user.firstName }}</td>
                  <td>{{ user.lastName }}</td>
                  <td>{{ user.roles }}</td>
                  <td>{{ user.status }}</td>
                  <td>{{ user.lastLogin | date : "short" }}</td>
                  <td>{{ user.auth.createdAt | localDate }}</td>
                </ng-container>

                <!--User Detail left menu-->
                <ng-template #detailListCols>
                  <td class="detail-area-container">
                    <div class="detail-area">
                      <div
                        [ngClass]="{
                          'detail-row': true,
                          'list-card-container': true
                        }"
                      >
                        <div class="row">
                          <div class="col-5 detail-font-bold-16px">
                            {{ user | displayName }}
                          </div>
                          <div class="col-5 detail-font-bold-12px">
                            {{ user.username }}
                          </div>
                          <div class="col-2 detail-item-right">
                            <dp-badge
                              [color]="
                                color[
                                  user.customerType?.toString().toLowerCase()
                                ]
                              "
                              [size]="''"
                              [text]="
                                user.customerType === 'RA'
                                  ? 'Military'
                                  : user.customerType
                              "
                            ></dp-badge>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-5 detail-font-bold-12px">
                            {{ user.organizationName }}
                          </div>
                          <div class="col-5 detail-font-bold-12px">
                            {{ user.tel | telNoCountry }}
                          </div>
                          <div class="col-2 detail-font-bold-12px">
                            <dp-badge
                              [color]="
                                color[user.status?.toString().toLowerCase()]
                              "
                              [size]="''"
                              [text]="user.status"
                            ></dp-badge>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-template>
              </tr>
            </tbody>
          </table>
        </app-dp-list>

        <app-dp-detail
          *ngIf="showDetail && selectedData"
          [showDetail]="showDetail"
        >
          <div class="user-detail-wrapper">
            <app-user-detail
              (detailUpdateEvent)="reload($event)"
              [userInfo]="selectedData"
            ></app-user-detail>
          </div>
        </app-dp-detail>
      </div>
    </div>
    <!-- end card body -->
  </div>
  <!-- end card -->
</div>
